<template>
  <c-container class="d-flex align-items-center min-vh-100">
    <c-row class="w-100 justify-content-center">
      <c-col md="6">
        <div class="clearfix">
          <h1 class="float-left text-h2 mr-4">500</h1>
          <h4 class="pt-3">Houston, we have a problem!</h4>
          <p class="text-muted">The page you are looking for is temporarily unavailable.</p>
        </div>
        <c-input class="mb-3" placeholder="What are you looking for?">
          <template #prepend-content><c-icon name="cil-magnifying-glass" /></template>
          <template #append>
            <c-button color="info">Search</c-button>
          </template>
        </c-input>
      </c-col>
    </c-row>
  </c-container>
</template>

<script>
export default {
  name: 'Page500',
};
</script>
